module.exports = __webpack_public_path__ + "img/image11.3a382e86.svg";